import { defineStore } from 'pinia';

export default defineStore('firebase', () => {
  const messaging = ref();

  const hasMessaging = computed((): boolean => {
    return !!messaging.value;
  });

  return {
    messaging,
    hasMessaging,
  };
});
